<template>
    <div>
    <section class="section-hero section-shaped my-0">
        <div class="shape " style ="background: black">
        </div>
        <div class="container shape-container d-flex align-items-center">
            <div class="col px-0">
                <div class="row justify-content-center align-items-center">
                    <div class="col-lg-7 text-center">
                        <img src="img/theme/MainBanner.jpg" style="width: 100%; height: 100%;" class="img-fluid">
                        <!--<p class="lead text-white mt-0 mb-5">DYDDAELTH</p>-->
                    </div>
                </div>
            </div>
        </div>
    </section>
        <section class="section section-lg pt--200 mt--500">
            <div class="container">
                <div class="row justify-content-center">
					<div class="mb-5">
						<h2>
							<strong>PLAYLISTS</strong>
						</h2>
					</div>
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="">
									  <iframe src="https://open.spotify.com/embed/playlist/7JlkYgjO8UoQRs8ZKIqPvF" width="270" height="380" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="">
									<iframe src="https://open.spotify.com/embed/playlist/4J3WfNHDh42etLT5pqRIAJ" width="270" height="380" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="">
									<iframe src="https://open.spotify.com/embed/playlist/58yJxkhcpuNgelMw5mBKBV" width="270" height="380" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
		<carousel></carousel>
		<section class="section section-lg">
            <div class="container">
                <div class="row justify-content-center text-center mb-lg">
                    <div class="col-lg-8">
                        <h2 class="display-3">The Artists</h2>
                        <p class="lead text-muted">Meet the Artists. Click to learn more.</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/theme/Fixed/Phantom.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Phantom</span>
                                    <small class="h6 text-muted"></small>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="https://www.facebook.com/DYDDoYOURDance/" type="primary" icon="fa fa-facebook" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="https://www.instagram.com/dyddoyourdance/
" type="primary" icon="fa fa-instagram" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="https://open.spotify.com/artist/71xCXxdD1YxvRURmmQBsb5?si=vt5fAsBTQqi0I4v46BPglQ" type="primary" icon="fa fa-spotify" rounded
                                                 icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/theme/Fixed/logos-1.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 300px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Logos</span>
                                    <small class="h6 text-muted"></small>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="https://instagram.com/logos_music_?igshid=YmMyMTA2M2Y=" type="warning" icon="fa fa-instagram" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="https://music.apple.com/us/artist/logos/1576030220" type="warning" icon="fa fa-apple" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="https://open.spotify.com/artist/0P2tPB4QSp91VIbAPWlKP9?si=G53LAKbBQH2EgLe70xcwlA" type="warning" icon="fa fa-spotify" rounded
                                                 icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/theme/Fixed/kybabie.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">ky babie</span>
                                    <small class="h6 text-muted"></small>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="https://music.apple.com/us/artist/ky-babie/1632700757" type="info" icon="fa fa-apple" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="https://instagram.com/dydkybabie?igshid=YmMyMTA2M2Y=" type="info" icon="fa fa-instagram" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="https://open.spotify.com/artist/1VdU9qDVSgskVArdJ3oIXS?si=Cm2WkL8tRhiuXhWCuRKLCQ" type="info" icon="fa fa-spotify" rounded
                                                 icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 col-lg-3 mb-5 mb-lg-0">
                        <div class="px-4">
                            <img v-lazy="'img/theme/Fixed/Persona.png'"
                                 class="rounded-circle img-center img-fluid shadow shadow-lg--hover"
                                 style="width: 200px;">
                            <div class="pt-4 text-center">
                                <h5 class="title">
                                    <span class="d-block mb-1">Persona</span>
                                    <small class="h6 text-muted"></small>
                                </h5>
                                <div class="mt-3">
                                    <base-button tag="a" href="https://twitter.com/akapersona" type="success" icon="fa fa-twitter" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="https://www.instagram.com/akapersona/" type="success" icon="fa fa-instagram" rounded
                                                 icon-only></base-button>
                                    <base-button tag="a" href="https://open.spotify.com/album/71AKaGyuor5xNnB8yJmikY?si=xdigDSWZSZuMZ3L7gTOABQ" type="success" icon="fa fa-spotify" rounded
                                                 icon-only></base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
			 <div class="row mt-4">
			<span class="col-5"></span>
			<div class="col-3">
			<router-link slot="brand" class="nav-link" to="/artist">
               <base-button type="primary">View All Artist</base-button> 
            </router-link>  
			</div>
			<span class="col-4"></span>
			</div>
        </section>
 <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-3 shape-skew" style="background: #002A46">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg pb-300">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">D.Y.D. Exists to Prepare Creators for What's Next</h2>
                        <p class="lead text-white">We combine music, artificial intelligence, and blockchain technology to help artists and brands create faster, market smarter, and own more of what they build.</p>
                    </div>
                </div>
                <div class="row row-grid mt-5">
                    <div class="col-lg-4">
                        <icon name="fa fa-music" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">Creative Excellence</h5>
                        <p class="text-white mt-3">We partner with artists who are ready to innovate. From production to performanceall artists are supported every step of the way.</p>
                    </div>
                    <div class="col-lg-4">
                        <icon name="ni ni-bulb-61" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">Tech-Powered Tools</h5>
                        <p class="text-white mt-3">AI-powered creation tools and blockchain technology help you accelerate your process, expand your reach, and retain ownership of your work.</p>
                    </div>
                    <div class="col-lg-4">
                        <icon name="ni ni-atom" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">Collaborative Growth</h5>
                        <p class="text-white mt-3">Modern creative entrepreneurship is built on transparency and shared success. Join a community designed for creators by creators.</p>
                    </div>
                </div>
            </div>
        </section>
        <!--<section class="section section-lg pt-lg-0 section-contact-us">
            <div class="container">
                <div class="row justify-content-center mt--300">
                    <div class="col-lg-8">
                        <card gradient="secondary" shadow body-classes="p-lg-5">
                            <h4 class="mb-1">Want to work with us?</h4>
                            <p class="mt-0">Let's get connected.</p>
							<form method="POST" action="send">
							<input type="text" name="name" key= "" value ="" class="form-control" id="nameid" placeholder="Your name">
							<input type="email" name="email" class="form-control mt-3" id="exampleInputEmail1" placeholder="Email Address">
							 <div class="form-group mt-3">
								<textarea class="form-control" name="message" id="exampleFormControlTextarea1" placeholder="Type a message..." rows="3"></textarea>
							 </div>
							<button type="submit" class="btn btn-primary">Submit</button>
							</form>
                        </card>
                    </div>
                </div>
            </div>
        </section>-->
    </div>
</template>
<script>
import Hero from "./components/Hero";
import BasicElements from "./components/BasicElements";
import Inputs from "./components/Inputs";
import CustomControls from "./components/CustomControls";
import Navigation from "./components/Navigation";
import JavascriptComponents from "./components/JavascriptComponents";
import Carousel from "./components/Carousel";
import Icons from "./components/Icons";
import Examples from "./components/Examples";
import DownloadSection from "./components/DownloadSection";

export default {
  name: "components",
  components: {
    Hero,
    BasicElements,
    Inputs,
    CustomControls,
    Navigation,
    JavascriptComponents,
    Carousel,
    Icons,
    Examples,
    DownloadSection
  }
};
</script>
